import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dad7e48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" }, null, -1))
const _hoisted_3 = { class: "p-d-flex p-jc-between" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "p-mb-2 p-mt-1 p-text-bold p-text-uppercase",
  style: {"color":"#004C97"}
}
const _hoisted_6 = { class: "p-grid" }
const _hoisted_7 = { class: "p-col" }
const _hoisted_8 = { class: "p-mr-2 p-text-uppercase" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " To : ", -1))
const _hoisted_10 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Receipt NO : ", -1))
const _hoisted_12 = { class: "p-mx-2 p-text-uppercase" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Receipt DATE : ", -1))
const _hoisted_14 = {
  key: 0,
  class: "p-mx-2 p-text-uppercase"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " REF NO : ", -1))
const _hoisted_16 = {
  key: 1,
  class: "p-mx-2 p-text-uppercase"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Bill NO : ", -1))
const _hoisted_18 = {
  key: 2,
  class: "p-mx-2 p-text-uppercase"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " TRANSFER TO : ", -1))
const _hoisted_20 = { class: "p-grid" }
const _hoisted_21 = { class: "p-col" }
const _hoisted_22 = {
  key: 0,
  class: "p-m-0"
}
const _hoisted_23 = {
  key: 1,
  class: "p-m-0"
}
const _hoisted_24 = {
  key: 2,
  class: "p-m-0"
}
const _hoisted_25 = { class: "p-grid" }
const _hoisted_26 = { class: "p-col-12" }
const _hoisted_27 = { class: "table table-bordered total-lables" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "dataTable-header p-grid p-m-0" }
const _hoisted_32 = { class: "p-col p-p-0" }
const _hoisted_33 = { class: "p-col p-p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "previewReceiptDailog",
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '100vw' },
    position: "top",
    class: "p-fluid p-m-0 p-dialog-maximized",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.receiptDialogName), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_MultiSelect, {
            modelValue: _ctx.selectedColumns,
            options: _ctx.optionalListOptionsTaxes,
            optionLabel: "header",
            "onUpdate:modelValue": _ctx.onToggle,
            placeholder: "Choose Columns",
            style: {"width":"20em"}
          }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_Button, {
            type: "button",
            label: "Print",
            icon: "pi pi-print",
            class: "p-button-warning pull-left",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printReceipt()))
          })
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.items.storeName), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.items.storeAddress), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.items.storeEmail), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.items.storePhone), 1),
          _createElementVNode("h6", null, "License No : " + _toDisplayString(_ctx.items.storeLicense), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "company-logo",
            src: _ctx.getCompanyURL(),
            alt: "Company Logo"
          }, null, 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.receiptTypeName), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.items.selectedProfile), 1)
          ]),
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.items.receiptNo), 1)
          ]),
          _createElementVNode("span", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.items.receiptDate)) + " / " + _toDisplayString(_ctx.formatTime(_ctx.items.createdDate)), 1)
          ]),
          (_ctx.items.returnReceipt != null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                _hoisted_15,
                _createTextVNode(" " + _toDisplayString(_ctx.items.returnReceipt), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.items.billNo != null && (_ctx.items.type == 'PUR' || _ctx.items.type == 'RPU'))
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                _hoisted_17,
                _createTextVNode(" " + _toDisplayString(_ctx.items.billNo), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.transferStoreName != '' && _ctx.items.type == 'TRN')
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                _hoisted_19,
                _createTextVNode(" " + _toDisplayString(_ctx.transferStoreName), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_DataTable, {
            value: _ctx.itemList,
            class: "p-datatable-sm p-datatable-gridlines",
            responsiveLayout: "scroll"
          }, {
            default: _withCtx(() => [
              (_ctx.checkOptionalCol('Mode'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 0,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    field: "mode",
                    header: "Mode"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                style: {"width":"10%"},
                class: "p-p-1",
                field: "itemName",
                header: "PRODUCT"
              }),
              _createVNode(_component_Column, {
                style: {"width":"10%"},
                class: "p-p-1",
                field: "genericName",
                header: "GENERIC"
              }),
              (_ctx.checkOptionalCol('Batch NO'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 1,
                    style: {"width":"8%"},
                    class: "p-p-1",
                    field: "batchNo",
                    header: "BATCH NO"
                  }))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol('Brand Name'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 2,
                    style: {"width":"10%"},
                    class: "p-p-1",
                    field: "brandName",
                    header: "BRAND"
                  }))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol('Brand Sector'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 3,
                    style: {"width":"10%"},
                    class: "p-p-1",
                    field: "sectorName",
                    header: "BRAND SECTOR"
                  }))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol('Category'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 4,
                    style: {"width":"10%"},
                    class: "p-p-1",
                    field: "categoryName",
                    header: "CATEGORY"
                  }))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol('Product Type'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 5,
                    style: {"width":"10%"},
                    class: "p-p-1",
                    field: "productType",
                    header: "PRODUCT TYPE"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                style: {"width":"5%"},
                class: "p-p-1",
                header: "Expiry"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.expiryDate(
												slotProps.data.expiryDate
											)), 1)
                ]),
                _: 1
              }),
              (_ctx.checkOptionalCol('Pack Size'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 6,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    field: "packSize",
                    header: "PACK SIZE"
                  }))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol('Strip Size'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 7,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    field: "sheetSize",
                    header: "STRIP SIZE"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                style: {"width":"5%"},
                class: "p-p-1",
                field: "unit",
                header: "UNITS"
              }),
              (_ctx.items.type == 'TRN')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 8,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    field: "freeUnit",
                    header: "GFT UNITS"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                style: {"width":"5%"},
                class: "p-p-1",
                field: "totalUnit",
                header: "TOTAL UNITS"
              }),
              (_ctx.items.type == 'PUR' || _ctx.items.type == 'RPU')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 9,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    field: "freeUnit",
                    header: "FREE QTY"
                  }))
                : _createCommentVNode("", true),
              (_ctx.items.type == 'PUR' || _ctx.items.type == 'RPU')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 10,
                    style: {"width":"10%"},
                    class: "p-p-1",
                    field: "supplierBonus",
                    header: "SUP BONUS"
                  }))
                : _createCommentVNode("", true),
              (_ctx.items.type == 'INE' || _ctx.items.type == 'RFD' || _ctx.items.type == 'TRN')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 11,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    header: "PRICE"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(
												slotProps.data.sellingPrice
											)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.items.type == 'PUR' || _ctx.items.type == 'RPU')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 12,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    header: "MRP"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(
												slotProps.data.mrp
											)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.items.type == 'PUR' || _ctx.items.type == 'RPU')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 13,
                    style: {"width":"10%"},
                    class: "p-p-1",
                    header: "PURCHASE PRICE"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(
												slotProps.data.purchasePrice
											)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol('Cus Disc'))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 14,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    header: "CUS DISC"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.fixDigits(
												slotProps.data.itemDisc
											)) + " % ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.items.type == 'PUR' || _ctx.items.type == 'RPU')
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 15,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    header: "MFG DISC"
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.fixDigits(
												slotProps.data.purchaseDisc
											)) + " % ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol(_ctx.taxNames[0].taxName))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 16,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    header: _ctx.taxNames[0].taxName
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.fixDigits(
												slotProps.data.tax1
											)) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol(_ctx.taxNames[1].taxName))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 17,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    header: _ctx.taxNames[1].taxName
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.fixDigits(
												slotProps.data.tax2
											)) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              (_ctx.checkOptionalCol(_ctx.taxNames[2].taxName))
                ? (_openBlock(), _createBlock(_component_Column, {
                    key: 18,
                    style: {"width":"5%"},
                    class: "p-p-1",
                    header: _ctx.taxNames[2].taxName
                  }, {
                    body: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(_ctx.fixDigits(
												slotProps.data.tax3
											)) + " % ", 1)
                    ]),
                    _: 1
                  }, 8, ["header"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Column, {
                style: {"width":"6%"},
                class: "p-p-1",
                header: "AMOUNT"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(
												slotProps.data.subTotal
											)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ]),
      (_ctx.items.description      != null    && _ctx.items.description     != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("small", null, "Description : " + _toDisplayString(_ctx.items.description), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.items.doctorDetails    != null    && _ctx.items.doctorDetails   != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("small", null, "Doctor Details : " + _toDisplayString(_ctx.items.doctorDetails), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.items.patientDetails   != null    && _ctx.items.patientDetails  != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createElementVNode("small", null, "Patient Details : " + _toDisplayString(_ctx.items.patientDetails), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("table", _hoisted_27, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, "Total Gross : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.items.totalGrossAmt)), 1),
              _createElementVNode("td", null, "Total Disc : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.items.discount)), 1),
              (_ctx.taxNames[0].show == true)
                ? (_openBlock(), _createElementBlock("td", _hoisted_28, " Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.items.totalTax1)), 1))
                : _createCommentVNode("", true),
              (_ctx.taxNames[1].show == true)
                ? (_openBlock(), _createElementBlock("td", _hoisted_29, " Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.items.totalTax2)), 1))
                : _createCommentVNode("", true),
              (_ctx.taxNames[2].show == true)
                ? (_openBlock(), _createElementBlock("td", _hoisted_30, " Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.items.totalTax3)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, "Total Tax : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.items.totalTax)), 1),
              _createElementVNode("td", null, "Net Total : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.items.totalBill)), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}